module.exports = __webpack_public_path__ + "img/16.721f3234.jpg";